<template>
  <router-view />
</template>

<script>
export default {
  name: 'BlankComponent'
}
</script>
